type Props = {
  label: string;
};

const NoDataValue = ({ label }: Props) => (
  <span aria-label={label}>
    <span aria-hidden="true">--</span>
  </span>
);

export default NoDataValue;
